import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, ListTodo, Calendar, Bell } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from './ui/button';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { icon: Home, label: 'Home', path: '/' },
    { icon: ListTodo, label: 'Tasks', path: '/tasks' },
    { icon: Calendar, label: 'Calendar', path: '/calendar' },
    { icon: Bell, label: 'Reminders', path: '/reminders' },
  ];

  return (
    <div className="flex flex-col min-h-screen bg-background">
      {/* Main Content */}
      <main className="flex-1 pb-16 md:pb-0 md:pl-16">
        {children}
      </main>

      {/* Mobile Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t md:hidden z-50">
        <div className="flex items-center justify-around p-2">
          {navItems.map((item) => (
            <Button
              key={item.path}
              variant="ghost"
              size="sm"
              className={cn(
                "flex flex-col items-center gap-1 h-auto py-2",
                location.pathname === item.path && "text-primary"
              )}
              onClick={() => navigate(item.path)}
            >
              <item.icon className="w-5 h-5" />
              <span className="text-xs">{item.label}</span>
            </Button>
          ))}
        </div>
      </nav>

      {/* Desktop Side Navigation */}
      <nav className="hidden md:flex fixed left-0 top-0 bottom-0 w-16 border-r bg-white flex-col items-center py-4 gap-2">
        {navItems.map((item) => (
          <Button
            key={item.path}
            variant="ghost"
            size="icon"
            className={cn(
              "w-12 h-12",
              location.pathname === item.path && "bg-primary/10 text-primary"
            )}
            onClick={() => navigate(item.path)}
          >
            <item.icon className="w-5 h-5" />
          </Button>
        ))}
      </nav>
    </div>
  );
};

export default Layout; 